"use strict";

define('libs/spf.helper',['backbone', 'underscore', './bind.helper', '../adapter/paginate', '../adapter/filter', '../adapter/param', '../model//paginate', '../model/filter', '../model/sort'], function (Backbone, _, BindHelper, PaginateAdapter, FilterAdapter, ParamAdapter, Paginate, Filter, Sort) {
  function SPFHelper(collection, options) {
    options = options || {};
    this.collection = collection;
    this.paginate = new Paginate(options.paginateDefaults || {});
    this.filter = new Filter(options.filterDefaults || {});
    this.sort = new Sort(options.sortDefaults || {});
    var autoFetch = options.autoFetch;
    options.autoFetch = false;
    collection.addAdapter(new PaginateAdapter(this.paginate, options.paginate)).addAdapter(new FilterAdapter(this.filter, options.filter)).addAdapter(new ParamAdapter(this.sort, options.sort));
    if (autoFetch) {
      this.setupAutoFetch();
    }
  }
  ;
  SPFHelper.extend = Backbone.View.extend;
  _.extend(SPFHelper.prototype, {
    setupAutoFetch: function setupAutoFetch() {
      if (this._didSetupAutoFetch) {
        return this;
      }
      this._didSetupAutoFetch = true;
      var fetch = _.debounce(_.bind(this.fetch, this, null), 1),
        collection = this.collection,
        self = this;
      collection.on('request', function (collection, xhr, options) {
        if (self._autoFetchXhr) {
          self._autoFetchXhr.abort();
          self._autoFetchXhr = null;
        }
        xhr.promise().tap(function () {
          self._autoFetchXhr = null;
        });
        self._autoFetchXhr = xhr;
      }, this);
      collection.once('request', function () {
        this.collection.listenTo(this.paginate, 'change:page change:size', function () {
          fetch();
        });
        this.paginate.on('change:size', this.resetPage, this);
        this.collection.listenTo(this.filter, 'change', function () {
          self.resetPage();
          fetch();
        });
        this.collection.listenTo(this.sort, 'change', function () {
          self.resetPage();
          fetch();
        });
      }, this);
      return this;
    },
    fetch: function fetch() {
      return this.collection.fetch.apply(this.collection, arguments);
    },
    setSortField: function setSortField(field) {
      this.sort.set(Sort.SORT_FIELD, field);
      return this;
    },
    setSortDirection: function setSortDirection(direction) {
      this.sort.set(Sort.SORT_DIRECTION, direction);
      return this;
    },
    setPaginateSize: function setPaginateSize(size) {
      this.paginate.set(Paginate.SIZE, size);
      return this;
    },
    setPaginatePage: function setPaginatePage(page) {
      this.paginate.set(Paginate.PAGE, page);
      return this;
    },
    setFilterParams: function setFilterParams(params) {
      this.filter.set(params);
      return this;
    },
    hasNextPage: function hasNextPage() {
      var currentPage = this.paginate.get(Paginate.PAGE),
        totalPages = this.paginate.get(Paginate.TOTAL_PAGES);
      if (_.isNumber(totalPages) && currentPage === totalPages) {
        return false;
      }
      return true;
    },
    incrementPage: function incrementPage() {
      var currentPage = this.paginate.get(Paginate.PAGE);
      if (this.hasNextPage()) {
        this.setPaginatePage(++currentPage);
      }
      return this;
    },
    decrementPage: function decrementPage() {
      var currentPage = this.paginate.get(Paginate.PAGE);
      if (currentPage > 1) {
        this.setPaginatePage(--currentPage);
      }
      return this;
    },
    resetPage: function resetPage() {
      this.paginate.set(Paginate.PAGE, 1);
      return this;
    },
    setupState: function setupState(state, filterKeys) {
      this.importState(state, filterKeys);
      this.bindState(state, filterKeys);
      return this;
    },
    importState: function importState(state, filterKeys) {
      var sortFields = [Sort.SORT_FIELD, Sort.SORT_DIRECTION],
        paginateFields = [Paginate.PAGE, Paginate.SIZE];
      function copyFields(src, dest, fields) {
        _.each(fields, function (key) {
          var value;
          if (src.has(key)) {
            var value = src.get(key);
            if (String(value).length > 0) {
              if (key == Paginate.PAGE || key == Paginate.SIZE) {
                value = Number(value) || 0;
              }
              dest.set(key, value);
            }
          }
        });
      }
      ;
      copyFields(state, this.paginate, paginateFields);
      copyFields(state, this.sort, sortFields);
      copyFields(state, this.filter, filterKeys);
      return this;
    },
    bindState: function bindState(state, filterKeys) {
      new BindHelper(this.paginate, state).bind(Paginate.PAGE).bind(Paginate.SIZE).transfer();
      new BindHelper(this.sort, state).bind(Sort.SORT_FIELD).bind(Sort.SORT_DIRECTION).transfer();
      new BindHelper(this.filter, state).bindAll(filterKeys).transfer();
      return this;
    }
  });
  return SPFHelper;
});

